<template>
  <el-card shadow="never">
    <span slot="header" style="font-weight: 600">异常</span>
    <Content :abnormal-type="realAbnormalPurchase_check" abnormal="Purchase" btnTitle="异常上报采购"
      @submitAbnormal="purchaseCall" ref="check_AbnormalSubmit_Purchase" />
    <el-divider></el-divider>
    <Content :abnormal-type="abnormalClient" abnormal="Client" btnTitle="异常上报客户" @submitAbnormal="clientCall"
      ref="check_AbnormalSubmit_Client" v-if="record.purchaseType == 0" />
  </el-card>
</template>

<script>
import Content from "./Content";
import { abnormalPurchase_check, abnormalClient } from "@/types";
import { inHouseDoStockIn, getApplyCode, createSignFlow } from "@/apis/inHouse";

export default {
  name: "AbnormalSubmit",
  components: {
    Content,
  },
  props: {
    record: {
      type: Object,
      required: true,
    },
    source:{
      required: false, // 必填
      default:''
    },
    overflow:{
      required: false, // 必填
      default:true
    }
  },
  data() {
    return {
      abnormalPurchase_check, // 上报采购异常
      abnormalClient, // 上报客户异常
      code: ["000000", "111111"],
    };
  },
  computed:{
    realAbnormalPurchase_check:function(){
      let data = [...this.abnormalPurchase_check]
      this.source === 'check_oem' && (data = data.map(i=>{return {...i,disabled:i.value === '102'?true:i.disabled}}))
      !this.overflow &&  (data = data.map(i=>{return {...i,disabled:i.value === '103'?true:i.disabled}}))
      return data
      // return this.source === 'check_oem'?this.abnormalPurchase_check.map(i=>{return {...i,disabled:i.value === '102'}}):this.abnormalPurchase_check
    }
  },
  mounted() { },
  methods: {
    purchaseCall: function (payload) {
      let childen = this.$refs.check_AbnormalSubmit_Purchase;
      console.log(childen.radio)
      const {
        expressNo,
        productSku,
        purchaseNo,
        purchaseType,
        operationType = 4,
        relationRespDTOList,
        stockInNum,
        confirmNum,
        num,
        inboundCode
      } = this.record;
      let orderCode
      console.log(childen.abnormalAmount,stockInNum,confirmNum,num)
      console.log(childen.abnormalAmount + stockInNum + confirmNum)

      if(childen.radio != '103'){
        if (Number(childen.abnormalAmount) + Number(stockInNum) + Number(confirmNum) > num) {
          this.$message.warning("超过采购总数");
          return;
        }
        if (relationRespDTOList.length && relationRespDTOList[0].orderNo) {
          orderCode = relationRespDTOList[0].orderNo
        } else {
          this.$message.warning("订单号缺失，请联系技术人员");
          return
        }
      }
      const params = {
        expressNo,
        productSku,
        purchaseNo,
        purchaseType,
        operationType: 4,
        exceptionCodeList: [childen.radio],
        picRelation: childen.qrCode,
        remark: childen.textarea,
        amount: childen.abnormalAmount,
        picRelation: payload.qrCode,
        orderCode: orderCode,
        inboundCode:inboundCode,
        volume: 'XS'
      };
      if (params.amount == 0 || !params.amount) {
        this.$message.error("入库数量必须大于0");
        return;
      }
      inHouseDoStockIn(params).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success("成功");
          this.$emit('DoStockIn', childen.radio == '102' ? undefined : data)
        }
      });
    },
    clientCall: function (val) {
      console.log(this.record)
      let childen = this.$refs.check_AbnormalSubmit_Client;
      const {
        expressNo,
        productSku,
        purchaseNo,
        purchaseType,
        operationType = 3,
        relationRespDTOList,
        stockInNum,
        confirmNum,
        num,
        inboundCode
      } = this.record;
      if (Number(childen.abnormalAmount) + Number(stockInNum) + Number(confirmNum) > num) {
        this.$message.warning("超过采购总数");
        return;
      }
      let orderCode
      if (relationRespDTOList.length && relationRespDTOList[0].orderNo) {
        orderCode = relationRespDTOList[0].orderNo
      } else {
        this.$message.warning("订单号缺失，请联系技术人员");
        return
      }
      const params = {
        expressNo,
        productSku,
        purchaseNo,
        purchaseType,
        operationType: 3,
        exceptionCodeList: childen.abnormals
          .filter((item) => item.checked)
          .map((item) => item.value),
        picRelation: childen.qrCode,
        remark: childen.textarea,
        amount: childen.abnormalAmount,
        orderCode: orderCode,
        inboundCode:inboundCode,
        volume: 'XS'
      };
      if (params.exceptionCodeList.length == 0) {
        this.$message.error("请勾选异常类型");
        return;
      }
      if (params.amount == 0 || !params.amount) {
        this.$message.error("入库数量必须大于0");
        return;
      }
      inHouseDoStockIn(params).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success("成功");
          this.$emit('DoStockIn', data)
        }
      });
    },
  },
};
</script>

<style scoped>

</style>
